import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import Grid from '@material-ui/core/Grid';
import Tooltip from '@material-ui/core/Tooltip';
import Button from '@material-ui/core/Button';
import HistoryIcon from '@material-ui/icons/History';
import ListIcon from '@material-ui/icons/List';
import RUReservationsTable from './UsedRentalsReservations/RUReservationsTable';
import RUReservationsOnHoldTable from './UsedRentalsOnHoldReservations/RUReservationsOnHoldTable';
import RUReservationsHistoricalTable from './UsedRentalsHistorical/RUReservationsHistoricalTable';


const styles = theme => ({
  paddingBorder: {
    padding: '16px 200px 0px 200px',
    borderBottom: '2px solid #003341'
  },
  group: {
    display: 'inline-block'
  },
  button: {
    margin: theme.spacing.unit
  },
  buttonSize: {
    width: '36px',
    height: '36px'
  }
});


class RUAllReservations extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      filterValue: 'personal',
      historical: false
    }
  }

  handleFilterData = event => {
    this.setState({ filterValue: event.target.value });
  };

  detectCancellation = () => {
    this.props.detectCancellation();
  };

  handleClickHistorical = () => {
    this.setState({ historical: !this.state.historical });
  };


  render() {
    const { classes } = this.props;

    return (
      <div>
        <Grid container>
          <Grid item xs={12} sm={12}>
            <Grid container justify='center'>
              <Grid item className={classes.paddingBorder}>
                <Tooltip title={this.state.historical ? 'Ativas' : 'Histórico'} placement='bottom' >
                  <Button variant='fab' color='primary' className={classNames(classes.button, classes.buttonSize)} onClick={this.handleClickHistorical}>
                    {this.state.historical ? <ListIcon /> : <HistoryIcon />}
                  </Button>
                </Tooltip>
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        {this.state.historical ?
          <RUReservationsHistoricalTable filterValue={this.state.filterValue} newReservation={this.props.newReservation} />
          :
          <React.Fragment>
            <RUReservationsTable newReservation={this.props.newReservation} detectCancellation={this.detectCancellation.bind(this)} />
            <RUReservationsOnHoldTable newReservation={this.props.newReservation} detectCancellation={this.detectCancellation.bind(this)} />
          </React.Fragment>
        }

      </div>
    );
  }
};

RUAllReservations.propTypes = {
  classes: PropTypes.object.isRequired,
  detectCancellation: PropTypes.func
};

const mapStateToProps = state => ({
  ...state,
});

export default connect(mapStateToProps)(withStyles(styles)(RUAllReservations));


// WEBPACK FOOTER //
// ./src/components/UsedRentals/UsedRentalsReservations/UsedRentalsAllReservations/RUAllReservations.js